import type React from "react";
import { Textarea } from "@planta-v2/pds-ui/textarea";
import { sanitizeWhatsAppTemplateParamText } from "@shared/utils/whatsapp-text-sanitizer.utils";

type TextareaProps = React.ComponentProps<typeof Textarea>;

export type WhatsAppTemplateSafeTextareaProps = TextareaProps;

export function WhatsAppTemplateSafeTextarea({
  onKeyDown,
  onChange,
  ...rest
}: WhatsAppTemplateSafeTextareaProps): React.JSX.Element {
  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLTextAreaElement>,
  ): void => {
    onKeyDown?.(event);
    if (event.defaultPrevented) {
      return;
    }
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ): void => {
    const sanitized = sanitizeWhatsAppTemplateParamText(event.target.value);
    if (sanitized !== event.target.value) {
      event.target.value = sanitized;
    }
    onChange?.(event);
  };

  return (
    <Textarea {...rest} onKeyDown={handleKeyDown} onChange={handleChange} />
  );
}
